/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@mui/material";
import { FC, Fragment, useContext } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { getTextFields } from "../variables/textFields";
import ToggleSwitch from "../../../../../shared/components/switch";
import { customizeValidationSchema } from "../variables/customSchema";
import { ZSSelectBox } from "../../../../../shared/components/selectBox";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import { QualificationType } from "../../../../../shared/enum";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const QualificationCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/master-datas/qualifications"
  );
  const { payload, setPayload } = useContext(SidebarContext);

  const textFields = getTextFields({}); //Get textboxes

  const initialValues = {
    name: "",
    qualificationType: null,
    enabled: true,
  };
  const qualificationForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      modifyData(
        `/qualification`,
        "post",
        {
          ...formData,
        },
        qualificationForm
      );
    },
  });
  const titleBar = {
    headerTitle: "Qualification - Create",
    title: "Create Qualification",
    buttonTitle: "Save",
    onClick: () => qualificationForm.handleSubmit(),
    dirty: qualificationForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              <Grid item xs={12}>
                <ToggleSwitch
                  status={qualificationForm?.values?.enabled}
                  handleChange={() =>
                    qualificationForm.setFieldValue(
                      "enabled",
                      !qualificationForm?.values?.enabled
                    )
                  }
                />
              </Grid>

              <Grid item md={6} sm={6} xs={12}>
                <ZSSelectBox
                  fieldProps={{
                    id: "qualification-type",
                    name: "qualificationType",
                    placeholder: "Select Qualification Type",
                    label: "Qualification Type",
                    required: true,
                  }}
                  options={[
                    {
                      label: QualificationType.Graduation,
                      value: QualificationType.Graduation,
                    },
                    {
                      label: QualificationType.PostGraduation,
                      value: QualificationType.PostGraduation,
                    },
                    {
                      label: QualificationType.Certification,
                      value: QualificationType.Certification,
                    },
                    {
                      label: QualificationType.Diploma,
                      value: QualificationType.Diploma,
                    },
                    {
                      label: QualificationType.Other,
                      value: QualificationType.Other,
                    },
                  ]}
                  form={qualificationForm}
                  value={qualificationForm.values?.qualificationType}
                />
              </Grid>

              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={qualificationForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};
export default QualificationCreate;
